import _tslib from "tslib";
import { dew as _errorsDew } from "./errors";
import { dew as _CharCodesDew } from "./syntax/CharCodes";
import { dew as _PDFContextDew } from "./PDFContext";
import { dew as _PDFObjectCopierDew } from "./PDFObjectCopier";
import { dew as _PDFWriterDew } from "./writers/PDFWriter";
import { dew as _PDFStreamWriterDew } from "./writers/PDFStreamWriter";
import { dew as _PDFHeaderDew } from "./document/PDFHeader";
import { dew as _PDFTrailerDew } from "./document/PDFTrailer";
import { dew as _PDFTrailerDictDew } from "./document/PDFTrailerDict";
import { dew as _PDFCrossRefSectionDew } from "./document/PDFCrossRefSection";
import { dew as _StandardFontEmbedderDew } from "./embedders/StandardFontEmbedder";
import { dew as _CustomFontEmbedderDew } from "./embedders/CustomFontEmbedder";
import { dew as _CustomFontSubsetEmbedderDew } from "./embedders/CustomFontSubsetEmbedder";
import { dew as _FileEmbedderDew } from "./embedders/FileEmbedder";
import { dew as _JpegEmbedderDew } from "./embedders/JpegEmbedder";
import { dew as _PngEmbedderDew } from "./embedders/PngEmbedder";
import { dew as _PDFPageEmbedderDew } from "./embedders/PDFPageEmbedder";
import { dew as _ViewerPreferencesDew } from "./interactive/ViewerPreferences";
import { dew as _PDFObjectDew } from "./objects/PDFObject";
import { dew as _PDFBoolDew } from "./objects/PDFBool";
import { dew as _PDFNumberDew } from "./objects/PDFNumber";
import { dew as _PDFStringDew } from "./objects/PDFString";
import { dew as _PDFHexStringDew } from "./objects/PDFHexString";
import { dew as _PDFNameDew } from "./objects/PDFName";
import { dew as _PDFNullDew } from "./objects/PDFNull";
import { dew as _PDFArrayDew } from "./objects/PDFArray";
import { dew as _PDFDictDew } from "./objects/PDFDict";
import { dew as _PDFRefDew } from "./objects/PDFRef";
import { dew as _PDFInvalidObjectDew } from "./objects/PDFInvalidObject";
import { dew as _PDFStreamDew } from "./objects/PDFStream";
import { dew as _PDFRawStreamDew } from "./objects/PDFRawStream";
import { dew as _PDFCatalogDew } from "./structures/PDFCatalog";
import { dew as _PDFContentStreamDew } from "./structures/PDFContentStream";
import { dew as _PDFCrossRefStreamDew } from "./structures/PDFCrossRefStream";
import { dew as _PDFObjectStreamDew } from "./structures/PDFObjectStream";
import { dew as _PDFPageTreeDew } from "./structures/PDFPageTree";
import { dew as _PDFPageLeafDew } from "./structures/PDFPageLeaf";
import { dew as _PDFFlateStreamDew } from "./structures/PDFFlateStream";
import { dew as _PDFOperatorDew } from "./operators/PDFOperator";
import { dew as _PDFOperatorNamesDew } from "./operators/PDFOperatorNames";
import { dew as _PDFObjectParserDew } from "./parser/PDFObjectParser";
import { dew as _PDFObjectStreamParserDew } from "./parser/PDFObjectStreamParser";
import { dew as _PDFParserDew } from "./parser/PDFParser";
import { dew as _PDFXRefStreamParserDew } from "./parser/PDFXRefStreamParser";
import { dew as _decodeDew } from "./streams/decode";
import { dew as _annotationDew } from "./annotation";
import { dew as _acroformDew } from "./acroform";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  tslib_1.__exportStar(_errorsDew(), exports);

  var CharCodes_1 = _CharCodesDew();

  Object.defineProperty(exports, "CharCodes", {
    enumerable: true,
    get: function () {
      return CharCodes_1.default;
    }
  });

  var PDFContext_1 = _PDFContextDew();

  Object.defineProperty(exports, "PDFContext", {
    enumerable: true,
    get: function () {
      return PDFContext_1.default;
    }
  });

  var PDFObjectCopier_1 = _PDFObjectCopierDew();

  Object.defineProperty(exports, "PDFObjectCopier", {
    enumerable: true,
    get: function () {
      return PDFObjectCopier_1.default;
    }
  });

  var PDFWriter_1 = _PDFWriterDew();

  Object.defineProperty(exports, "PDFWriter", {
    enumerable: true,
    get: function () {
      return PDFWriter_1.default;
    }
  });

  var PDFStreamWriter_1 = _PDFStreamWriterDew();

  Object.defineProperty(exports, "PDFStreamWriter", {
    enumerable: true,
    get: function () {
      return PDFStreamWriter_1.default;
    }
  });

  var PDFHeader_1 = _PDFHeaderDew();

  Object.defineProperty(exports, "PDFHeader", {
    enumerable: true,
    get: function () {
      return PDFHeader_1.default;
    }
  });

  var PDFTrailer_1 = _PDFTrailerDew();

  Object.defineProperty(exports, "PDFTrailer", {
    enumerable: true,
    get: function () {
      return PDFTrailer_1.default;
    }
  });

  var PDFTrailerDict_1 = _PDFTrailerDictDew();

  Object.defineProperty(exports, "PDFTrailerDict", {
    enumerable: true,
    get: function () {
      return PDFTrailerDict_1.default;
    }
  });

  var PDFCrossRefSection_1 = _PDFCrossRefSectionDew();

  Object.defineProperty(exports, "PDFCrossRefSection", {
    enumerable: true,
    get: function () {
      return PDFCrossRefSection_1.default;
    }
  });

  var StandardFontEmbedder_1 = _StandardFontEmbedderDew();

  Object.defineProperty(exports, "StandardFontEmbedder", {
    enumerable: true,
    get: function () {
      return StandardFontEmbedder_1.default;
    }
  });

  var CustomFontEmbedder_1 = _CustomFontEmbedderDew();

  Object.defineProperty(exports, "CustomFontEmbedder", {
    enumerable: true,
    get: function () {
      return CustomFontEmbedder_1.default;
    }
  });

  var CustomFontSubsetEmbedder_1 = _CustomFontSubsetEmbedderDew();

  Object.defineProperty(exports, "CustomFontSubsetEmbedder", {
    enumerable: true,
    get: function () {
      return CustomFontSubsetEmbedder_1.default;
    }
  });

  var FileEmbedder_1 = _FileEmbedderDew();

  Object.defineProperty(exports, "FileEmbedder", {
    enumerable: true,
    get: function () {
      return FileEmbedder_1.default;
    }
  });
  Object.defineProperty(exports, "AFRelationship", {
    enumerable: true,
    get: function () {
      return FileEmbedder_1.AFRelationship;
    }
  });

  var JpegEmbedder_1 = _JpegEmbedderDew();

  Object.defineProperty(exports, "JpegEmbedder", {
    enumerable: true,
    get: function () {
      return JpegEmbedder_1.default;
    }
  });

  var PngEmbedder_1 = _PngEmbedderDew();

  Object.defineProperty(exports, "PngEmbedder", {
    enumerable: true,
    get: function () {
      return PngEmbedder_1.default;
    }
  });

  var PDFPageEmbedder_1 = _PDFPageEmbedderDew();

  Object.defineProperty(exports, "PDFPageEmbedder", {
    enumerable: true,
    get: function () {
      return PDFPageEmbedder_1.default;
    }
  });

  var ViewerPreferences_1 = _ViewerPreferencesDew();

  Object.defineProperty(exports, "ViewerPreferences", {
    enumerable: true,
    get: function () {
      return ViewerPreferences_1.default;
    }
  });
  Object.defineProperty(exports, "NonFullScreenPageMode", {
    enumerable: true,
    get: function () {
      return ViewerPreferences_1.NonFullScreenPageMode;
    }
  });
  Object.defineProperty(exports, "ReadingDirection", {
    enumerable: true,
    get: function () {
      return ViewerPreferences_1.ReadingDirection;
    }
  });
  Object.defineProperty(exports, "PrintScaling", {
    enumerable: true,
    get: function () {
      return ViewerPreferences_1.PrintScaling;
    }
  });
  Object.defineProperty(exports, "Duplex", {
    enumerable: true,
    get: function () {
      return ViewerPreferences_1.Duplex;
    }
  });

  var PDFObject_1 = _PDFObjectDew();

  Object.defineProperty(exports, "PDFObject", {
    enumerable: true,
    get: function () {
      return PDFObject_1.default;
    }
  });

  var PDFBool_1 = _PDFBoolDew();

  Object.defineProperty(exports, "PDFBool", {
    enumerable: true,
    get: function () {
      return PDFBool_1.default;
    }
  });

  var PDFNumber_1 = _PDFNumberDew();

  Object.defineProperty(exports, "PDFNumber", {
    enumerable: true,
    get: function () {
      return PDFNumber_1.default;
    }
  });

  var PDFString_1 = _PDFStringDew();

  Object.defineProperty(exports, "PDFString", {
    enumerable: true,
    get: function () {
      return PDFString_1.default;
    }
  });

  var PDFHexString_1 = _PDFHexStringDew();

  Object.defineProperty(exports, "PDFHexString", {
    enumerable: true,
    get: function () {
      return PDFHexString_1.default;
    }
  });

  var PDFName_1 = _PDFNameDew();

  Object.defineProperty(exports, "PDFName", {
    enumerable: true,
    get: function () {
      return PDFName_1.default;
    }
  });

  var PDFNull_1 = _PDFNullDew();

  Object.defineProperty(exports, "PDFNull", {
    enumerable: true,
    get: function () {
      return PDFNull_1.default;
    }
  });

  var PDFArray_1 = _PDFArrayDew();

  Object.defineProperty(exports, "PDFArray", {
    enumerable: true,
    get: function () {
      return PDFArray_1.default;
    }
  });

  var PDFDict_1 = _PDFDictDew();

  Object.defineProperty(exports, "PDFDict", {
    enumerable: true,
    get: function () {
      return PDFDict_1.default;
    }
  });

  var PDFRef_1 = _PDFRefDew();

  Object.defineProperty(exports, "PDFRef", {
    enumerable: true,
    get: function () {
      return PDFRef_1.default;
    }
  });

  var PDFInvalidObject_1 = _PDFInvalidObjectDew();

  Object.defineProperty(exports, "PDFInvalidObject", {
    enumerable: true,
    get: function () {
      return PDFInvalidObject_1.default;
    }
  });

  var PDFStream_1 = _PDFStreamDew();

  Object.defineProperty(exports, "PDFStream", {
    enumerable: true,
    get: function () {
      return PDFStream_1.default;
    }
  });

  var PDFRawStream_1 = _PDFRawStreamDew();

  Object.defineProperty(exports, "PDFRawStream", {
    enumerable: true,
    get: function () {
      return PDFRawStream_1.default;
    }
  });

  var PDFCatalog_1 = _PDFCatalogDew();

  Object.defineProperty(exports, "PDFCatalog", {
    enumerable: true,
    get: function () {
      return PDFCatalog_1.default;
    }
  });

  var PDFContentStream_1 = _PDFContentStreamDew();

  Object.defineProperty(exports, "PDFContentStream", {
    enumerable: true,
    get: function () {
      return PDFContentStream_1.default;
    }
  });

  var PDFCrossRefStream_1 = _PDFCrossRefStreamDew();

  Object.defineProperty(exports, "PDFCrossRefStream", {
    enumerable: true,
    get: function () {
      return PDFCrossRefStream_1.default;
    }
  });

  var PDFObjectStream_1 = _PDFObjectStreamDew();

  Object.defineProperty(exports, "PDFObjectStream", {
    enumerable: true,
    get: function () {
      return PDFObjectStream_1.default;
    }
  });

  var PDFPageTree_1 = _PDFPageTreeDew();

  Object.defineProperty(exports, "PDFPageTree", {
    enumerable: true,
    get: function () {
      return PDFPageTree_1.default;
    }
  });

  var PDFPageLeaf_1 = _PDFPageLeafDew();

  Object.defineProperty(exports, "PDFPageLeaf", {
    enumerable: true,
    get: function () {
      return PDFPageLeaf_1.default;
    }
  });

  var PDFFlateStream_1 = _PDFFlateStreamDew();

  Object.defineProperty(exports, "PDFFlateStream", {
    enumerable: true,
    get: function () {
      return PDFFlateStream_1.default;
    }
  });

  var PDFOperator_1 = _PDFOperatorDew();

  Object.defineProperty(exports, "PDFOperator", {
    enumerable: true,
    get: function () {
      return PDFOperator_1.default;
    }
  });

  var PDFOperatorNames_1 = _PDFOperatorNamesDew();

  Object.defineProperty(exports, "PDFOperatorNames", {
    enumerable: true,
    get: function () {
      return PDFOperatorNames_1.default;
    }
  });

  var PDFObjectParser_1 = _PDFObjectParserDew();

  Object.defineProperty(exports, "PDFObjectParser", {
    enumerable: true,
    get: function () {
      return PDFObjectParser_1.default;
    }
  });

  var PDFObjectStreamParser_1 = _PDFObjectStreamParserDew();

  Object.defineProperty(exports, "PDFObjectStreamParser", {
    enumerable: true,
    get: function () {
      return PDFObjectStreamParser_1.default;
    }
  });

  var PDFParser_1 = _PDFParserDew();

  Object.defineProperty(exports, "PDFParser", {
    enumerable: true,
    get: function () {
      return PDFParser_1.default;
    }
  });

  var PDFXRefStreamParser_1 = _PDFXRefStreamParserDew();

  Object.defineProperty(exports, "PDFXRefStreamParser", {
    enumerable: true,
    get: function () {
      return PDFXRefStreamParser_1.default;
    }
  });

  var decode_1 = _decodeDew();

  Object.defineProperty(exports, "decodePDFRawStream", {
    enumerable: true,
    get: function () {
      return decode_1.decodePDFRawStream;
    }
  });

  tslib_1.__exportStar(_annotationDew(), exports);

  tslib_1.__exportStar(_acroformDew(), exports); //# sourceMappingURL=index.js.map


  return exports;
}